import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { HelpersService } from '../../../core/services/helpers.service';
import { OperationsService } from '../../../core/services/operations.service';
import { ViewManagerService } from '../../../core/services/view-manager-service';
import { CensimentoDocumenti } from '../../models/sezioni/sezione-censimento-documenti/censimento-documenti';
import {
  SezioneCensimentoDocumenti
} from '../../models/sezioni/sezione-censimento-documenti/sezione-censimento-documenti';
import { Provenienza } from '../../models/tipologiche/provenienza';
import { TipoDocumento } from '../../models/tipologiche/tipo-documento';

@Component({
  selector: 'div [censimento-documenti-form-add]',
  templateUrl: './censimento-documenti-form.component.html',
})
export class CensimentoDocumentiFormComponent {

  @Input() title: string;
  @Output() onReturn: EventEmitter<any> = new EventEmitter<any>();
  request: CensimentoDocumenti;
  requestIniziale:CensimentoDocumenti;
  censimentoForm: FormGroup;
  urlUpdate: string;
  idSezione: string;
  sezione: SezioneCensimentoDocumenti;
  idFascicolo: string;
  inserimento: boolean;
  quantitaIniziale: number;

  // options
  provenienzaOptions: Provenienza[] = [];
  tipoDocumentoOptions: TipoDocumento[] = [];


  constructor(protected operationService: OperationsService, private campiForm: FormBuilder, private helpers: HelpersService, private viewManager: ViewManagerService, private modalNotifyService: ModalNotifyService) {
  }


  inizializza(urlUpdate, idFascicolo, idSezione, sezione, inserimento, censimento = new CensimentoDocumenti()) {
    this.urlUpdate = urlUpdate;
    this.idFascicolo = idFascicolo;
    this.idSezione = idSezione;
    this.sezione = sezione;
    this.inserimento = inserimento;
    if (!inserimento) {
      this.request = censimento;
      this.quantitaIniziale = censimento.quantita;
      this.requestIniziale = {...censimento};
    }
    this.populateSelect();
    this.createForm();
  }


  createForm() {
    if(this.inserimento) {
      this.request = new CensimentoDocumenti();
    } else {
      this.request = {...this.requestIniziale};
    }
    this.censimentoForm = this.campiForm.group({
      tipoProvenienzaDocumento: [this.request.tipoProvenienzaDocumento, Validators.required],
      tipoDocumento: [this.request.tipoDocumento, Validators.required],
      quantita: [this.request.quantita, Validators.required]
    });
  }

  populateSelect() {
    this.helpers.getTipiProvenienzaDocumento().subscribe(response => this.provenienzaOptions = (<Provenienza[]>response));
    this.helpers.getTipiDocumenti().subscribe(response => this.tipoDocumentoOptions = (<TipoDocumento[]>response));
  }

  isCensimentoPresente() : boolean {
    return this.sezione && this.sezione.censimentoDocumenti && !!this.sezione.censimentoDocumenti.find(censimento=>censimento.tipoProvenienzaDocumento.id === this.request.tipoProvenienzaDocumento.id && censimento.tipoDocumento.id === this.request.tipoDocumento.id);
  }

  isQuantitaValid() : boolean {
    return !!(this.request.quantita >= 1);
  }

  update() {
    if(this.isCensimentoPresente() && this.inserimento){
      this.modalNotifyService.customMessage('Censimento documenti gi\u00E0 presente');
    } else {
      if (this.inserimento) {
        this.operationService.addCensimentoDocumenti(this.urlUpdate, this.idFascicolo, this.idSezione, this.request).subscribe(response => {
          this.onReturn.emit(response)
        });
      } else {
        this.operationService.updateCensimentoDocumenti(this.urlUpdate, this.idSezione, this.request).subscribe(response => {
          this.onReturn.emit({
            response: response,
            request: {...this.request}
          });
        })
      }
    }
  }
}
